import React, { useEffect, useState } from "react";
import {
  Layout,
  Typography,
  Button,
  Input,
  Table,
  Modal,
  Form,
  Select,
  Row,
  Col,
  Flex,
  Tag,
  DatePicker,
} from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import {
  AddCorporate,
  EditEnterprises,
  fetchCorporate,
  GetCompanyId,
} from "src/redux/actions/corporateAction";
import dayjs from "dayjs";
import CustomTableLoader from "src/components/common/CustomTableLoader";

const { Title, Text } = Typography;
const { Search } = Input;
const { Option } = Select;
const Corporate: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const dataSource = useSelector((state: any) => state.corporate.data ?? []);
  const loading = useSelector((state: RootState) => state.corporate.loading);
  const update = useSelector((state: any) => state.corporate.update);
  const companyData = useSelector((state: any) => state.corporate.Iddata);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);

  const [searchText, setSearchText] = useState<string>("");

  const handleSearch = (value: string) => {
    setSearchText(value);
  };
  const showAddModal = async () => {
    setIsEdit(false);
    setEditId(null);
    await dispatch(GetCompanyId());
    form.resetFields();
    if (companyData?.[0]?.CompanyID) {
      form.setFieldsValue({
        CompanyID: companyData[0].CompanyID,
      });
    }
    setIsModalVisible(true);
  };

  useEffect(() => {
    dispatch(fetchCorporate());
    dispatch(GetCompanyId());
  }, []);

  useEffect(() => {
    if (update?.success) {
      dispatch(fetchCorporate());
      dispatch(GetCompanyId());
    }
  }, [update.success]);

  useEffect(() => {
    if (update?.success) {
      setIsModalVisible(false);
      form.resetFields();
    }
  }, [update?.success]);

  const handleAdd = (values: any) => {
    const payload = {
      ID: editId,
      CompanyID: values.CompanyID,
      CompanyName: values.CompanyName,
      gst: values.gst,
      MD_Name: values.MD_Name,
      MD_Mobno: values.MD_Mobno,
      Auth_Mobno: values.Auth_Mobno,
      Authorized_Person: values.Authorized_Person,
      Address: values.Address,
      is_credit: values.is_credit,
      status: values.status,
      Dateofjoining: values.Dateofjoining
        ? dayjs(values.Dateofjoining).format("DD/MM/YYYY")
        : "",
    };
    if (isEdit) {
      dispatch(EditEnterprises(payload));
    } else {
      dispatch(AddCorporate(payload));
    }
    form.resetFields();
  };

  const columns: any = [
    {
      title: "Company ID",
      dataIndex: "CompanyID",
      key: "CompanyID",
    },
    {
      title: "Company Name",
      dataIndex: "CompanyName",
      key: "CompanyName",
    },
    {
      title: "GST Number",
      dataIndex: "gst",
      key: "gst",
    },
    {
      title: "MD Name",
      dataIndex: "MD_Name",
      key: "MD_Name",
    },
    {
      title: "Auth Person",
      dataIndex: "Authorized_Person",
      key: "Authorized_Person",
    },
    {
      title: "Auth Mobile",
      dataIndex: "Auth_Mobno",
      key: "Auth_Mobno",
    },
    {
      title: "Date Of Joining",
      dataIndex: "Dateofjoining",
      key: "Dateofjoining",
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
    },
    {
      title: "Credit Status",
      dataIndex: "is_credit",
      key: "is_credit",
      render: (value: any) => (
        <span style={{ color: value === "1" ? "green" : "red" }}>
          {value === "1" ? "True" : "False"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <Tag color={status === "Active" ? "#64903a" : "#c16352"}>{status}</Tag>
      ),
    },
    {
      title: "More",
      key: "moreInfo",
      align: "center",
      width: 70,

      render: (_text: any, record: any) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => handleOpenEditModal(record)}
        ></Button>
      ),
    },
  ];
  const handleOpenEditModal = (record: any) => {
    setIsEdit(true);
    setEditId(record.ID);
    form.setFieldsValue({
      CompanyID: record.CompanyID,
      CompanyName: record.CompanyName,
      gst: record.gst,
      MD_Name: record.MD_Name,
      MD_Mobno: record.MD_Mobno,
      Auth_Mobno: record.Auth_Mobno,
      Authorized_Person: record.Authorized_Person,
      Address: record.Address,
      is_credit: record.is_credit,
      status: record.status,
      Dateofjoining: record.Dateofjoining
        ? dayjs(record.Dateofjoining, ["DD/MM/YYYY", "YYYY-MM-DD"])
        : dayjs(),
    });

    setIsModalVisible(true);
  };

  const filteredData = dataSource.filter((item: any) => {
    const search = searchText.toLowerCase();
    const safe = (val: any) =>
      val !== undefined && val !== null ? String(val).toLowerCase() : "";
    return (
      safe(item.CompanyName).includes(search) ||
      safe(item.CompanyID).includes(search) ||
      safe(item.gst).includes(search) ||
      safe(item.MD_Name).includes(search) ||
      safe(item.Authorized_Person).includes(search)
    );
  });

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Flex style={{ flexDirection: "column", rowGap: "10px" }}>
        <Title
          level={3}
          style={{
            fontSize: "35px",
            fontWeight: "bolder",
            color: "black",
            fontFamily: "serif",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            margin: 0,
          }}
        >
          Enterprises
        </Title>
        <Flex
          style={{
            marginBottom: 16,
            display: "flex",
            justifyContent: "end",
            gap: "2%",
          }}
        >
          <Text strong style={{ fontSize: "20px" }}>
            Total Enterprises: {dataSource.length}
          </Text>
          <Button
            style={{ backgroundColor: "#884399", color: "white" }}
            icon={<PlusOutlined />}
            onClick={showAddModal}
          >
            Add
          </Button>
          <Search
            placeholder="Search"
            allowClear
            onChange={(e) => handleSearch(e.target.value)}
            onSearch={handleSearch}
            style={{ width: 180 }}
          />
        </Flex>
        <Table
          loading={{
            spinning: loading,
            indicator: <CustomTableLoader />,
          }}
          columns={columns}
          dataSource={filteredData}
          bordered
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 100,
          }}
          className="custom-dark-table"
        />
      </Flex>
      <Modal
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        footer={null}
        title={
          <div
            style={{
              backgroundColor: "#884399",
              color: "white",
              textAlign: "center",
              padding: "10px 0",
              borderRadius: "4px",
              fontSize: "16px",
              fontWeight: "bold",
              marginTop: "20px",
              marginBottom: "4%",
            }}
          >
            Enterprises Details
          </div>
        }
      >
        <Form
          form={form}
          layout="horizontal"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          onFinish={handleAdd}
          initialValues={{
            CompanyID: companyData?.[0]?.CompanyID,
            Dateofjoining: dayjs(),
          }}
        >
          <Row gutter={[24, 16]}>
            <Col span={12}>
              <Form.Item
                name="CompanyID"
                // label="Company ID"
                rules={[{ required: true, message: "Company ID is required" }]}
              >
                <Input
                  style={{ fontWeight: "bolder", color: "red" }}
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="CompanyName"
                // label="Company Name"
                rules={[
                  { required: true, message: "Company Name is required" },
                ]}
              >
                <Input placeholder="Company Name" autoFocus />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="gst">
                <Input placeholder="GST Number" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="MD_Name">
                <Input placeholder="MD Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="MD_Mobno">
                <Input
                  placeholder="MD Number"
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="Authorized_Person">
                <Input placeholder="Auth Person" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="Auth_Mobno">
                <Input
                  placeholder="Auth Mobile"
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="Address">
                <Input placeholder="Address" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="is_credit"
                // label="Credit Status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select placeholder="Select Credit status">
                  <Option value="1">True</Option>
                  <Option value="0">False</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="status"
                // label="Status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select placeholder="Select status">
                  <Option value="Active">Active</Option>
                  <Option value="Inactive">Inactive</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Dateofjoining"
                // label="Date of joining"
                rules={[
                  {
                    required: true,
                    message: "Please select the amount received date!",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%", fontWeight: "bolder" }}
                  format="DD/MM/YYYY"
                  disabledDate={(current) =>
                    current && current.isAfter(dayjs())
                  }
                  placeholder="Date of Joining"
                />
              </Form.Item>
            </Col>
          </Row>
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ backgroundColor: "#873398", borderColor: "#873398" }}
              // onClick={handleAdd}
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    </Layout>
  );
};

export default Corporate;
